var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow right",
    className: "arrow",
    d: "M-3.49691e-07 8C-3.2555e-07 8.55229 0.447715 9 1 9L9.76078 9C10.6517 9 11.0979 10.0771 10.4679 10.7071L7.28753 13.8875C6.89503 14.28 6.89785 14.9172 7.29381 15.3062C7.68483 15.6904 8.31242 15.6876 8.70003 15.3L15.2929 8.70711C15.6834 8.31658 15.6834 7.68342 15.2929 7.29289L8.70003 0.700027C8.31241 0.312415 7.68483 0.309639 7.2938 0.693806C6.89785 1.08281 6.89503 1.72003 7.28753 2.11253L10.4679 5.29289C11.0979 5.92286 10.6517 7 9.76079 7L1 7C0.447716 7 -3.73832e-07 7.44772 -3.49691e-07 8Z",
    fill: "#161C25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.21721d8b3a185149793fdd099429d39e.svg";
export { ForwardRef as ReactComponent };